import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import { Slider } from 'src/domains/casino/webview/CasinoGames/home-games/slider/Slider';
import { GamesWrapper } from 'src/domains/casino/webview/CasinoGames/home-games/games-home-view/GamesHome.style';
import { AppCasinoState, CasinoGameModelExt } from 'src/domains/casino/state/AppCasino.state';
import { SingleGameExt } from 'src/domains/casino/webview/CasinoGames/single-game-ext/SingleGameExt';

interface GamesSliderPropsType {
    appCasinoState: AppCasinoState;
    customHeader?: React.ReactNode;
    gameModels: Array<CasinoGameModelExt>;
    onViewAllClick?: () => void;
    title: string | JSX.Element;
    withoutLikeAndInfo?: boolean;
    withoutViewAll?: boolean;
}

export const GamesSliderCasino = observer('GamesSliderCasino', (props: GamesSliderPropsType) => {
    const { appCasinoState, customHeader, gameModels, onViewAllClick, title, withoutLikeAndInfo, withoutViewAll } =
        props;

    if (gameModels.length === 0) {
        return null;
    }

    const showLikeAndInfo = withoutLikeAndInfo === true ? false : undefined;

    return (
        <Slider
            customHeader={customHeader}
            onViewAllClick={onViewAllClick}
            title={title}
            withoutViewAll={withoutViewAll}
        >
            <GamesWrapper>
                {gameModels.map((gameModel) => {
                    return (
                        <SingleGameExt
                            appCasinoState={appCasinoState}
                            key={gameModel.id}
                            gameModel={gameModel}
                            wrapperType='slider'
                            showLikeAndInfo={showLikeAndInfo}
                        />
                    );
                })}
            </GamesWrapper>
        </Slider>
    );
});
